import ProjectFileApi from '@/api/rest/ProjectFileApi';

export default new ProjectFileApi();
